import axe from './axiosClient';
import { downloadFile } from './axeHelpers';
import { backOfficeAxe } from './backofficeClient';

export const modifyRequestDataBackOffice = (requestToken) => backOfficeAxe.get(`/insurance-request/${requestToken}/modify-data`);

export const updateActiveCustomerBackOffice = (customerId, data) => backOfficeAxe.post(`/active-customers/${customerId}/update`, data);

export const greeniaPrivacyPolicyBackOffice = async () => {
  const response = await backOfficeAxe.get('/greenia-privacy-policy', {
    responseType: 'blob',
  });

  if (response.status !== 200) {
    return;
  }

  downloadFile(response.data);
};

export const downloadResourceDocsBackoffice = async (id, professionId) => {
  let profid = null;
  if (professionId >= 53 && professionId <= 180) {
    profid = 53;
  } else {
    profid = professionId;
  }

  const response = await backOfficeAxe.get(
    `/download-resource-document/${id}/${profid}`,
    {
      responseType: 'blob',
    },
  );

  if (response.status !== 200) {
    return;
  }

  downloadFile(response.data);
};

export const deleteDocument = (documentId) => axe.post(`/document/delete/${documentId}`, {});

export const apiDownloadDocument = (documentId) => axe.get(`/document/${documentId}/download`);

export const apiDownloadBrokerDocument = (documentId) => axe.get(`/download-broker-document/${documentId}`);

export const apiDownloadBrokerReport = (documentId) => axe.get(`/download-broker-report/${documentId}`);

export const apiDownloadBrokerBill = (compensation_bill_id) => axe.get(`/download-broker-bill/${compensation_bill_id}`);

export const apiDownloadBrokerCompensationProof = (compensation_proof_id) => axe.get(`/download-broker-compensation-proof/${compensation_proof_id}`);

export const uploadDocument = (data) => axe.post('/upload-document', data);

export const documentMethodManualUpload = (quotationId, documentId, data) => axe.post(
  `/quotations/${quotationId}/manually/sign/documents/${documentId}/upload-signed`,
  data,
);

export const apiUploadOptionalDocument = (data) => axe.post('/optional-documents/upload', data);

export const apiDeleteOptionalDocument = (documentId) => axe.post(`/optional-documents/delete/${documentId}`, {});

export const apiDownloadOptionalDocument = (documentId) => axe.get(`/optional-documents/${documentId}/download`);

export const apiOptionalDocumentMethodManualUpload = (quotationId, documentId, data) => axe.post(
  `/quotations/${quotationId}/manually/sign/optional-documents/${documentId}/upload-signed`,
  data,
);
